<template>
    <app-framework>
        <template v-slot:title>
            <tw-divider color="white"
                        width="56"
                        class="mb-3"
            ></tw-divider>
            Case Studies
        </template>
        <!--        <div class="rotated-background-section bg-block" v-if="!loading"></div>-->
        <!--        <div class="bg-circle" v-if="!loading"></div>-->
        <!--        <div class="bg-dot" v-if="!loading"></div>-->
<!--        <loader class="mt-20" v-if="loading"></loader>-->
        <row>
            <column class="text-secondary" cols="full">
                <row class="mb-10">
                    <column
                        class="xs:text-center sm:text-center md:text-right xs:items-center sm:items-center md:items-end"
                        cols="full"
                    >
                        <tw-divider class="mb-5" color="primary" width="56"></tw-divider>
                        <div class="poppins-bold tracking-normal xs:text-3xl sm:text-5xl leading-tight mt-5">
                            Case Studies
                        </div>
                        <div
                            class="text-xl tracking-normal leading-snug xs:w-full sm:w-full md:w-4/5 lg:w-3/5 xl:1/2 my-16">
                            These are some specific case studies of organizations that enabled total talent through
                            fitt.
                        </div>
                    </column>
                    <column cols="full">
                        <row align="stretch" justify="center">
                            <column :key="index"
                                    align="center"
                                    class="justify-center z-10 p-4"
                                    v-for="({fields, sys}, index) in $route.params.studies"
                            >
                                <card class="flex flex-col text-secondary h-full relative"
                                      no-padding
                                      style="min-width: 300px; max-width: 300px; min-height: 450px; max-height: 450px;"
                                >
                                    <img
                                        :class="fields.coverImage.fields ? 'contain' : 'center'"
                                        :src="fields.coverImage.fields ? fields.coverImage.fields.file.url : fields.logo.fields.file.url"
                                        alt=""
                                        class="round-top"
                                    >
                                    <div class="px-6 pb-6">
                                        <tw-divider class="mt-8 mb-6" color="primary" width="56"></tw-divider>
                                        <div
                                            class="uppercase w-full poppins-bold tracking-wide overflow-hidden leading-tight mb-5 ellipse-on-three"
                                        >
                                            {{ fields.title }}
                                        </div>
                                        <div class="tracking-normal leading-tight mb-5 overflow-hidden ellipse-on-three"
                                        >
                                            {{ fields.intro }}
                                        </div>
                                        <div class="absolute" style="bottom: 20px;">
                                            <router-link
                                                :to="{ name: 'CaseStudy', params: {studySlug: fields.slug, studyId: sys.id}}"
                                                append
                                                class="uppercase poppins-bold tracking-wide leading-tight text-primary"
                                            >Read More
                                            </router-link>
                                        </div>
                                    </div>
                                </card>
                            </column>
                        </row>
                    </column>
                </row>
            </column>
        </row>
    </app-framework>
</template>

<script>
    export default {
        name: "CaseStudies",
        props: {
            // studies: {
            //     type: Object
            // },
            // data: {
            //     type: String
            // }
        },
        components: {
            'app-framework': () => import('@/components/layout/AppFramework.vue'),
            // 'loader': () => import('@/components/display/Loader.vue'),
            'tw-divider': () => import('@/components/Divider.vue'),
            card: () => import('@/components/Card.vue'),
        },
        data: () => ({
            studies: null,
            // loading: false
        }),
        methods: {
            requireSrc(src) {
                return require('@/assets/images/' + src);
            },
            // getStudies() {
            //     this.$contentful.getEntries({content_type: 'caseStudy'}).then(
            //         (resp) => {
            //             this.studies = resp.items;
            //             this.loading = false;
            //         }
            //     ).catch(
            //         (err) => {
            //             console.log(err);
            //             this.loading = false;
            //         }
            //     );
            // }
        },
        mounted() {
            // this.getStudies();
            this.studies = this.$route.params.studies;
        },
        // beforeEnter: (to, from, next) => {
        //     console.log('here');
        //     router.app.$contentful.getEntries({content_type: 'caseStudy'}).then(
        //         (resp) => {
        //             console.log(resp.items);
        //             // console.log(to.params.studies);
        //             next({params: {studies: resp.items}});
        //             // this.studies = resp.items;
        //             // this.loading = false;
        //         }
        //     ).catch(
        //         (err) => {
        //             console.log(err);
        //             // this.loading = false;
        //         }
        //     );
        // },
    }
</script>

<style scoped>
    .round-top {
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
    }

    .contain {
        object-fit: cover;
        height: 200px;
        max-width: 100%;
    }

    .center {
        object-fit: contain;
        height: 200px;
        max-width: 280px;
        margin-left: auto;
        margin-right: auto;
    }

    .ellipse-on-three {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
    }

    /*.rotated-background-section {*/
    /*    width: 1944px;*/
    /*    height: 916px;*/
    /*    position: absolute;*/
    /*    border-radius: 166px;*/
    /*}*/

    /*.bg-block {*/
    /*    background: linear-gradient(to bottom, rgba(1, 116, 234, 1), rgba(1, 116, 234, 0));*/
    /*    opacity: 0.05;*/
    /*    left: 48px;*/
    /*    top: 230px;*/
    /*    transform: translateX(616px) translateY(1012px) rotateZ(-7deg);*/
    /*    z-index: 0;*/
    /*}*/

    /*.bg-circle {*/
    /*    width: 166px;*/
    /*    height: 166px;*/
    /*    background-color: rgba(1, 116, 234, 0.1);*/
    /*    border-radius: 50%;*/
    /*    transform: translate(-650px, 350px);*/
    /*}*/

    /*.bg-dot {*/
    /*    width: 24px;*/
    /*    height: 24px;*/
    /*    box-shadow: 0 0 0 1px rgba(1, 116, 234, 0.2);*/
    /*    border-radius: 50%;*/
    /*    transform: translate(-760px, 530px);*/
    /*}*/

    /*@media only screen and (max-width: 413px) {*/
    /*    .bg-block {*/
    /*        background: linear-gradient(to bottom, rgba(1, 116, 234, 1), rgba(1, 116, 234, 0));*/
    /*        !*background-color: red;*!*/
    /*        opacity: 0.05;*/
    /*        left: 48px;*/
    /*        top: 115px;*/
    /*        transform: translateX(114px) translateY(742px) rotateZ(-7deg);*/
    /*        z-index: 0;*/
    /*    }*/

    /*    .bg-circle {*/
    /*        width: 166px;*/
    /*        height: 166px;*/
    /*        background-color: rgba(1, 116, 234, 0.1);*/
    /*        border-radius: 50%;*/
    /*        left: -10px;*/
    /*        top: 610px;*/
    /*        position: absolute;*/
    /*    }*/

    /*    .bg-dot {*/
    /*        width: 24px;*/
    /*        height: 24px;*/
    /*        box-shadow: 0 0 0 1px rgba(1, 116, 234, 0.2);*/
    /*        border-radius: 50%;*/
    /*        left: 15px;*/
    /*        top: 790px;*/
    /*        position: absolute;*/
    /*    }*/
    /*}*/

    /*@media only screen and (min-width: 414px) and (max-width: 639px) {*/
    /*    .bg-block {*/
    /*        background: linear-gradient(to bottom, rgba(1, 116, 234, 1), rgba(1, 116, 234, 0));*/
    /*        !*background-color: red;*!*/
    /*        opacity: 0.05;*/
    /*        left: 48px;*/
    /*        top: 115px;*/
    /*        transform: translateX(114px) translateY(542px) rotateZ(-7deg);*/
    /*        z-index: 0;*/
    /*    }*/

    /*    .bg-circle {*/
    /*        width: 166px;*/
    /*        height: 166px;*/
    /*        background-color: rgba(1, 116, 234, 0.1);*/
    /*        border-radius: 50%;*/
    /*        left: -10px;*/
    /*        top: 610px;*/
    /*        position: absolute;*/
    /*    }*/

    /*    .bg-dot {*/
    /*        width: 24px;*/
    /*        height: 24px;*/
    /*        box-shadow: 0 0 0 1px rgba(1, 116, 234, 0.2);*/
    /*        border-radius: 50%;*/
    /*        left: 15px;*/
    /*        top: 790px;*/
    /*        position: absolute;*/
    /*    }*/
    /*}*/

    /*@media only screen and (min-width: 640px) and (max-width: 1919px) {*/
    /*    .bg-block {*/
    /*        background: linear-gradient(to bottom, rgba(1, 116, 234, 1), rgba(1, 116, 234, 0));*/
    /*        opacity: 0.05;*/
    /*        left: 48px;*/
    /*        top: 115px;*/
    /*        transform: translateX(314px) translateY(542px) rotateZ(-7deg);*/
    /*        z-index: 0;*/
    /*    }*/

    /*    .bg-circle {*/
    /*        width: 166px;*/
    /*        height: 166px;*/
    /*        background-color: rgba(1, 116, 234, 0.1);*/
    /*        border-radius: 50%;*/
    /*        left: 60px;*/
    /*        top: 770px;*/
    /*        position: absolute;*/
    /*    }*/

    /*    .bg-dot {*/
    /*        width: 24px;*/
    /*        height: 24px;*/
    /*        box-shadow: 0 0 0 1px rgba(1, 116, 234, 0.2);*/
    /*        border-radius: 50%;*/
    /*        left: 40px;*/
    /*        top: 950px;*/
    /*        position: absolute;*/
    /*    }*/
    /*}*/

    /*@media only screen and (min-width: 1920px) {*/
    /*    .bg-block {*/
    /*        background: linear-gradient(to bottom, rgba(1, 116, 234, 1), rgba(1, 116, 234, 0));*/
    /*        opacity: 0.05;*/
    /*        left: 48px;*/
    /*        top: 115px;*/
    /*        transform: translateX(914px) translateY(842px) rotateZ(-7deg);*/
    /*        z-index: 0;*/
    /*    }*/

    /*    .bg-circle {*/
    /*        width: 166px;*/
    /*        height: 166px;*/
    /*        background-color: rgba(1, 116, 234, 0.1);*/
    /*        border-radius: 50%;*/
    /*        !*left: 60px;*!*/
    /*        !*top: 920px;*!*/
    /*        transform: translateX(-800px) translateY(140px);*/
    /*        position: absolute;*/
    /*    }*/

    /*    .bg-dot {*/
    /*        width: 24px;*/
    /*        height: 24px;*/
    /*        box-shadow: 0 0 0 1px rgba(1, 116, 234, 0.2);*/
    /*        border-radius: 50%;*/
    /*        !*left: 40px;*!*/
    /*        !*top: 1100px;*!*/
    /*        transform: translateX(-840px) translateY(320px);*/
    /*        position: absolute;*/
    /*    }*/
    /*}*/
</style>